export default "__VITE_ASSET__638704d8__"